import { Modal } from '@/components/ui'

interface PreviewTemplateProps {
  template: string
  visible: boolean
  setVisible: (visible: boolean) => void
  title?: string
}

export const PreviewTemplate = (props: PreviewTemplateProps): JSX.Element => {
  const { template, visible, setVisible, title } = props

  return (
    <Modal
      open={visible}
      onOpenChange={setVisible}
      contentClassName="p-0"
      wrapperClassName="p-0 rounded-3xl"
      size="auto"
    >
      <div
        className="p-0 overflow-hidden"
        dangerouslySetInnerHTML={{
          __html: template,
        }}
      />
    </Modal>
  )
}
